var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "con-btn" }, [
    _c("div", { staticClass: "column-layout flex" }, [
      _c("div", { staticClass: "form-single" }, [
        _c("div", { staticClass: "title required" }, [_vm._v("通知标题")]),
        _vm._v(" "),
        _c("div", [_c("span", [_vm._v(_vm._s(_vm.servicerNotice.title))])])
      ]),
      _vm._v(" "),
      _vm.showTag == null || _vm.showTag
        ? _c("div", { staticClass: "form-single" }, [
            _c("div", { staticClass: "title required" }, [_vm._v("通知对象")]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content" },
              [
                _c(
                  "el-table",
                  {
                    staticStyle: { width: "100%" },
                    attrs: {
                      data: _vm.servicerNoticeTargets,
                      border: "",
                      height: "250"
                    }
                  },
                  [
                    _c("el-table-column", {
                      attrs: { prop: "comName", label: "公司" }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { prop: "departName", label: "部门" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(rows) {
                            return [
                              rows.row.departId != null &&
                              rows.row.departId != -1
                                ? _c("span", [
                                    _vm._v(_vm._s(rows.row.departName))
                                  ])
                                : _c("span", [_vm._v("全部")])
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { prop: "postName", label: "岗位" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(rows) {
                            return [
                              rows.row.postId != null && rows.row.postId != -1
                                ? _c("span", [
                                    _vm._v(_vm._s(rows.row.postName))
                                  ])
                                : _c("span", [_vm._v("全部")])
                            ]
                          }
                        }
                      ])
                    })
                  ],
                  1
                )
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "form-single" }, [
        _c("div", { staticClass: "title required" }, [_vm._v("内容简介")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "content" },
          [
            _c("el-input", {
              attrs: {
                type: "textarea",
                disabled: _vm.noEditor == null ? false : _vm.noEditor
              },
              model: {
                value: _vm.servicerNotice.digest,
                callback: function($$v) {
                  _vm.$set(_vm.servicerNotice, "digest", $$v)
                },
                expression: "servicerNotice.digest"
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-single" }, [
        _c("div", { staticClass: "title required" }, [_vm._v("内容信息")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "content" },
          [
            _c("swb-ck-editor", {
              ref: "theCkEditor",
              attrs: {
                content: _vm.content,
                imageXtHandler: _vm.imageXtHandler
              }
            })
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ceb173b2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ceb173b2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/servicer/ServicerNoticeView.vue
// module id = 2108
// module chunks = 1